module.exports = __webpack_public_path__ + "img/Restaurant10.2b656f72.png";